var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "64", height: "64", viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M0 0H64V64H0z" }),
      React.createElement("path", { d: "M27 31L38 31C47.3888407 31 55 38.6111593 55 48L55 52 55 52 55 53C55 55.209139 53.209139 57 51 57L14 57C11.790861 57 10 55.209139 10 53L10 52 10 52 10 48C10 38.6111593 17.6111593 31 27 31zM31.5 6L32.5 6C38.2989899 6 43 10.7010101 43 16.5L43 18.5C43 24.2989899 38.2989899 29 32.5 29L31.5 29C25.7010101 29 21 24.2989899 21 18.5L21 16.5C21 10.7010101 25.7010101 6 31.5 6z", fill: "#D3D3D3" }),
      React.createElement("path", { fill: "#B2B2B2", d: "M38 31L44 36.5 36 52z" }),
      React.createElement("path", { fill: "#B2B2B2", transform: "matrix(-1 0 0 1 50.4 0)", d: "M23.2 31L29.2 36.5 21.2 52z" })
    )
  );
});